import React, { useEffect, useState } from "react";

const ScrollToTopButton: React.FC = () => {
    const [isVisible, setIsVisible] = useState(false);

    useEffect(() => {
        const handleScroll = () => {
            // Show the button when the user scrolls down 100px
            setIsVisible(window.scrollY > 100);
        };

        window.addEventListener("scroll", handleScroll);

        return () => {
            window.removeEventListener("scroll", handleScroll);
        };
    }, []);

    const scrollToTop = () => {
        window.scrollTo({ top: 0, behavior: "smooth" });
    };

    if (!isVisible) {
        return null; // Return null when the button is not visible
    }

    return (
        <button
            onClick={scrollToTop}
            style={{
                position: "fixed",
                bottom: "3rem",
                right: "3rem",
                width: "3rem",
                height: "3rem",
                borderRadius: "50%",
                backgroundColor: "#007bff",
                color: "#fff",
                border: "none",
                boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
                cursor: "pointer",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                zIndex: 1000,
            }}
            aria-label="Scroll to top"
        >
            ↑
        </button>
    );
};

export default ScrollToTopButton;